(function ( $ ) {

    $.fn.ddContainer = function() {
        return $(this).each(function(){
            var $that = $(this),
            $ddButton = $that.find('.js-dropdown-btn'),
            $ddList = $that.find('.js-dropdown'),
            $options = $that.find('.js-select option'),
            selected;

            $ddList.empty();

            $options.each(function() {
                var text = $(this).text();
                var value = $(this).val();

                if ($(this).is(':selected')) {
                    selected = text;
                };

                $ddList.append('<li class="js-dropdown-item" data-value="'+value+'">' + text + '</li>');

            });

            $ddList.find('.js-dropdown-item').ddItem();
            $ddButton.text(selected);
        });
    };
}( jQuery ));


(function ( $ ) {

    $.fn.ddButton = function() {
        return $(this).on('click', function(e){
            e.preventDefault();
            e.stopPropagation();

            if (!$(this).next().is('.open')) {
                $('.js-dropdown').removeClass('open');
            }

            $(this).next().toggleClass('open');
        });
    };

}( jQuery ));


(function ( $ ) {

    $.fn.ddItem = function() {

        // Kenny
        var li = $('.js-dropdown-item'),
            first = $('.js-dropdown-item:first-child');

        first.addClass('active');
        // End Kenny

        return $(this).on('click', function(){
            var value = $(this).data('value'),
            $parent = $(this).parent();

            $parent.toggleClass('open');
            $parent.prevAll('.js-select').val(value).trigger('change');

            // Kenny
            li.removeClass('active');
            $(this).addClass('active');
            // End Kenny
        });
    };

}( jQuery ));


(function ( $ ) {

    $.fn.ddSelect = function() {
        return $(this).on('change', function(){
            var text = $(this).find('option:selected').text();

            $(this).next().text(text);
        });
    };

}( jQuery ));

$(function() {
    if ($('.js-dropdown-container').length) {
        $('.js-dropdown-container').ddContainer();
    };

    if ($('.js-dropdown-btn').length) {
        $('.js-dropdown-btn').ddButton();
    };

    if ($('.js-select').length) {
        $('.js-select').ddSelect();
    };


    if ($('.js-dropdown').length) {
        $('body').on('click', function(){
            $('.js-dropdown').removeClass('open');
        });

        $('.js-dropdown').hover(function(){
            $('.js-body').addClass('no-scroll');
        }, function(){
            $('.js-body').removeClass('no-scroll');
        });
    };
});